module.exports = __webpack_public_path__ + "img/payments2.bcab5e3b.jpg";